import cx from "classnames";
const dots = "mx-[1px] inline-block h-1 w-1 animate-blink rounded-md";
const LoadingDots = ({
  className,
  containerClass = "mx-2"
}) => {
  return <span className={`${containerClass} inline-flex items-center`} data-sentry-component="LoadingDots" data-sentry-source-file="LoadingDots.jsx">
      <span className={cx(dots, className)} />
      <span className={cx(dots, "animation-delay-[200ms]", className)} />
      <span className={cx(dots, "animation-delay-[400ms]", className)} />
    </span>;
};
export default LoadingDots;